import RegularButton from 'components/CustomButtons/Button.jsx';
import { put } from 'helpers/apiHelpers';
import { TableCell } from '@material-ui/core';
import { toast } from 'react-toastify';

const TableButtonSaveSection = ({ mailingOption, t, state, setState }) => (
  <TableCell>
    <RegularButton
      disabled={!mailingOption.hasChanged}
      color="success"
      onClick={() => {
        put(mailingOption['@id'], mailingOption)
          // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
          .then(
            () => {
              const newMailing = [...state.mailing];

              const optionToChange = newMailing.find(
                newMailingOption => newMailingOption.id === mailingOption.id
              );
              optionToChange.hasChanged = false;
              setState({
                mailing: newMailing,
              });
              toast.success(t('notify.changesSaved'));
            },
            () =>
              toast.error(t('notify.cannotSave', 'Nie udało się zapisać zmian'))
          )
          // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
          .finally(() => window.location.reload());
      }}
    >
      {t('common.shared.save', 'Zapisz')}
    </RegularButton>
  </TableCell>
);

export default TableButtonSaveSection;
